import React, { useState } from 'react'
import { Backdrop, Box, Button, CircularProgress, Container, Tooltip } from '@mui/material'
import { BaseGrid, NotificationAlert, Title } from 'components'
import { useQuery } from 'react-query'
import apiClient from '../../../services/apiClient'
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import * as XLSX from 'xlsx'

function ConcoursDMJ () {
  const [inscriptions, setInscriptions] = useState([])
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  useQuery(
    ['fetchInscriptionsConcoursDMJ'],
    async () => {
      setLoading(true)
      return await apiClient.fetchInscriptionsConcoursDMJ()
    },
    {
      enabled: true,
      onSuccess: ({ data }) => {
        setLoading(false)
        setInscriptions(data)
      },
      onError: () => {
        setLoading(false)
        setError(true)
      }
    }
  )

  const handleExport = () => {
    const feuille = XLSX.utils.json_to_sheet(
      inscriptions.map(({ nom, adresse, courriel, telephone }) => ({
        Nom: nom,
        Adresse: adresse,
        Courriel: courriel,
        Téléphone: telephone
      }))
    )
    const classeur = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(classeur, feuille, 'Participants')
    XLSX.writeFile(classeur, `concours-dmj-participants-${format(new Date(), 'yyyy-MM-dd')}.xlsx`)
  }

  const columns = [
    { name: 'nom', label: 'Nom' },
    { name: 'adresse', label: 'Adresse' },
    { name: 'courriel', label: 'Courriel' },
    { name: 'telephone', label: 'Téléphone' },
    {
      name: 'createdAt',
      label: "Date d'inscription",
      options: {
        customBodyRender: (value) =>
          value
            ? format(new Date(value), 'dd MMM yyyy HH:mm', { locale: fr })
            : '-'
      }
    }
  ]

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color='secondary' size={40} />
      </Backdrop>
      <NotificationAlert
        openNotification={error}
        type='error'
        message='Erreur lors de la récupération des inscriptions.'
      />
      <Container maxWidth='xl' sx={{ pt: 5, pb: 5 }}>
        <Title
          pageTitle='concours.Title'
          noAdd
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Button
            variant='outlined'
            startIcon={<FileDownloadIcon />}
            onClick={handleExport}
            disabled={!inscriptions.length}
          >
            Exporter en Excel
          </Button>
        </Box>
        <BaseGrid gridData={inscriptions} gridColumn={columns} />
      </Container>
    </>
  )
}

export default ConcoursDMJ
